import {
  LayoutDashboard, BookOpen, CalendarDays, Code2,
  Trophy, BarChart3, MessageSquare, Swords,
} from 'lucide-react';

import type { NavGroup } from '@/components/AppSidebar';

const ic = 'h-[18px] w-[18px]';

export const studentNavGroups: NavGroup[] = [
  { label: 'Learn', items: [
    { to: '/dashboard',   label: 'Home',       icon: <LayoutDashboard className={ic} /> },
    { to: '/courses',     label: 'My Courses', icon: <BookOpen className={ic} /> },
    { to: '/schedule',    label: 'Schedule',   icon: <CalendarDays className={ic} /> },
  ]},
  { label: 'Practice', items: [
    { to: '/problems',    label: 'Problems',   icon: <Code2 className={ic} /> },
    { to: '/hackathons',  label: 'Hackathons', icon: <Swords className={ic} /> },
    { to: '/leaderboard', label: 'Leaderboard',icon: <Trophy className={ic} /> },
  ]},
  { label: 'Me', items: [
    { to: '/progress',    label: 'Progress',     icon: <BarChart3 className={ic} /> },
    { to: '/messages',    label: 'Messages',     icon: <MessageSquare className={ic} /> },
  ]},
];
